module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-6.11ea67bc.mp3";